import React from "react";

function NFTCollectionLaunchHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Collection Launch
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Bring your creative vision to life and enter the thriving
                    world of digital assets with a unique NFT collection. At
                    Xeer Technology, we provide expert guidance and end-to-end
                    development services to help you launch an NFT collection
                    that captivates collectors, artists, and investors alike.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTCollectionLaunchHero;
